import React, { useEffect } from 'react';
import { I_FRAMES_URL } from '../../utils/Constant';

const IceOpsPage: React.FunctionComponent = () => {
  useEffect(() => {
    window.open(I_FRAMES_URL.ICE_OPS, '_blank');
  }, []);

  return null; // no UI needed
};

export default IceOpsPage;
